import React, {useCallback, useReducer, useState} from 'react'
import {findDOMNode} from "react-dom"

export function useForceUpdate() {
    const [, dispatch] = useReducer(x => x + 1, 0)
    return useCallback(() => dispatch(), [])
}

export function useConstructor(callBack:callback) {
    const [hasBeenCalled, setHasBeenCalled] = useState(false);
    if (hasBeenCalled) return;
    callBack();
    setHasBeenCalled(true);
}

export function addClassToNode(node: Element , className:string) {

    if (node) {
        node.classList.add(className);
    } else {
        console.warn("#ADD-CLASS-NODE-NOT-FOUND-3")
    }
}

export function removeClassFromNode(node: Element , className:string) {
    if (node) {
        node.classList.remove(className)
    } else {
        console.warn("#ADD-CLASS-NOT-FOUND-5 (No node passed)", className)
    }
}

export function toggleClassForNode(node: Element , className:string, shouldAdd:boolean) {
    if (shouldAdd) {
        addClassToNode(node, className)
    } else {
        removeClassFromNode(node, className)
    }
}

// export function useConstructor(callBack = () => {}) {
//     const [hasBeenCalled, setHasBeenCalled] = useState(false);
//     if (hasBeenCalled) return;
//     callBack();
//     setHasBeenCalled(true);
// }

export function stopPropagation(e: React.SyntheticEvent) : void {
    e.stopPropagation()
}

export function addClass(component: React.ReactInstance , className:string) {
    const node: any = findDOMNode(component)

    if (node) {
        node.classList.add(className)
    } else {
        console.warn("#ADD-CLASS-NOT-FOUND")
    }
}

export function removeClass(component: React.ReactInstance , className:string) {
    const node: any = findDOMNode(component)

    if (node) {
        node.classList.remove(className)
    } else {
        console.warn("#REMOVE-CLASS-NOT-FOUND")
    }
}

export function toggleClass(component: React.ReactInstance , className:string, shouldAdd:boolean) {

    if (shouldAdd) addClass(component, className)
    else removeClass(component, className)

}

// export function componentHeight(component:React.ReactInstance) {
//     const size = componentSize(component)
//     return size.height
// }

export function componentSize(component: React.ReactInstance):DOMRect {

    const node = findDOMNode(component)

    if (!node) {
        console.warn("componentSize NOT FOUND #REACT-UTILS-3")
    }

    // @ts-ignore
    return node.getBoundingClientRect()

}

export function getDOMRect(component: any):DOMRect {
    const node = findDOMNode(component)

    if (!node) {
        console.warn("getDOMRect NOT FOUND #REACT-UTILS-3")
        return new DOMRect()
    }

    // @ts-ignore
    return node.getBoundingClientRect()
}